module.exports = __webpack_public_path__ + "d9002ac75668e20f5d9f3a99bd8243dd.svg";